<script>
export default {
  name: "user_profile_icon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.63993 9.15332C8.67455 9.15332 9.51327 8.3146 9.51327 7.27999C9.51327 6.24538 8.67455 5.40666 7.63993 5.40666C6.60532 5.40666 5.7666 6.24538 5.7666 7.27999C5.7666 8.3146 6.60532 9.15332 7.63993 9.15332Z"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.1002 13.4667C11.1002 11.9133 9.55351 10.6466 7.64017 10.6466C5.72684 10.6466 4.18018 11.9067 4.18018 13.4667"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.0002 8.33333C14.0002 11.8333 11.1668 14.6667 7.66683 14.6667C4.16683 14.6667 1.3335 11.8333 1.3335 8.33333C1.3335 4.83333 4.16683 2 7.66683 2C8.54016 2 9.3735 2.17333 10.1335 2.49333C10.0468 2.75999 10.0002 3.04 10.0002 3.33333C10.0002 3.83333 10.1402 4.30667 10.3868 4.70667C10.5202 4.93333 10.6935 5.13998 10.8935 5.31331C11.3602 5.73998 11.9802 6 12.6668 6C12.9602 6 13.2402 5.95332 13.5002 5.85999C13.8202 6.61999 14.0002 7.46 14.0002 8.33333Z"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.3333 3.33333C15.3333 3.54667 15.3067 3.75333 15.2533 3.95333C15.1933 4.22 15.0867 4.48 14.9467 4.70667C14.6267 5.24667 14.1133 5.66665 13.5 5.85999C13.24 5.95332 12.96 6 12.6667 6C11.98 6 11.36 5.73998 10.8933 5.31332C10.6933 5.13998 10.52 4.93333 10.3867 4.70667C10.14 4.30667 10 3.83333 10 3.33333C10 3.04 10.0467 2.75999 10.1333 2.49333C10.26 2.10666 10.4733 1.76002 10.7533 1.47335C11.24 0.973349 11.92 0.666668 12.6667 0.666668C13.4533 0.666668 14.1667 1.00668 14.6467 1.55335C15.0733 2.02668 15.3333 2.65333 15.3333 3.33333Z"
      stroke="white"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.66 3.31999H11.6733"
      stroke="white"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.6665 2.34668V4.34001"
      stroke="white"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
